export default __webpack_public_path__ + "static/media/element_78.b0bf0e3c.webp";